import React, { Component } from 'react'
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import { observer } from 'mobx-react'
import Tooltip from '../../../../comum/components/Tooltip';
import Checkbox from '../../../../comum/components/Checkbox';
import CardsImportacao from './CardsImportacao';

@observer
export default class TabelaOrcamentoImport extends Component {

    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    }

    render() {
        
        if(this.controller.tabelaDados.length === 0) {
            return null;
        } else {
            return (
                <div>
                    {
                        this.controller.tabelaDados.map(tabela => {
                            const selectRow = {
                                mode: 'checkbox',
                                selected: this.controller.listaSelecionados.map(select => select.OsId),
                                nonSelectable: this.controller.listaNaoSelecionaveis,
                                selectionHeaderRenderer: ({ indeterminate, ...rest }) => (
                                    <Tooltip tooltipText={`Clique aqui para ${rest.checked || indeterminate ? "desmarcar" : "selecionar"} todos os registros`}>
                                        <Checkbox ativo={rest.checked} onClick={() => { }} />
                                    </Tooltip>
                                ),
                                selectionRenderer: ({ mode, ...rest }) =>
                                    <Checkbox ativo={rest.checked} onClick={() => { }} bloqueado={rest.disabled} />,
                                onSelect: (row, isSelect, rowIndex, e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    this.controller.selecionar(row)
                                },
                                onSelectAll: (isSelect, rows, e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    
                                    while (this.controller.hasMore) {
                                        this.controller.loadNextTurn()
                                    }
                    
                                    this.controller.selecionarTodos(rows, isSelect)
                                    
                                    if (isSelect) {
                                        const selecao = this.controller.listaSelecionados.map((item, index) => {
                                            return item.OsId
                                        })
                                        return selecao
                                    } else {
                                        return []
                                    }
                                },
                            }
                            return(
                                <div>
                                    <div style={{borderTop:'2px solid #ffdccd', borderBottom:'2px solid #ffdccd', backgroundColor: '#ffede5', padding: '15px 10px', fontWeight:'bold', fontFamily: 'Nunito', fontSize:'16px', color: '#ff7147'}}>
                                        {tabela.Servicos[0].Prestador}
                                    </div>
                                    {
                                        window.innerWidth > 991
                                        ?<ToolkitProvider
                                            keyField="OsId"
                                            data={[...tabela.Servicos]}
                                            columns={this.controller.todasColunas}
                                        >
                                            {props => <div>
                                                <BootstrapTable bootstrap4
                                                    striped
                                                    bordered={false}
                                                    selectRow={selectRow}
                                                    classes="tabela tabela-layout"
                                                    {...props.baseProps}
                                                />
                                                </div>
                                            }
                                        </ToolkitProvider> 
                                        :<div className="mt-2">
                                            {
                                                tabela.Servicos.map((servico) => {
                                                    return(
                                                        <CardsImportacao
                                                            key={servico.OsId}
                                                            controller={this.controller}
                                                            data={servico}
                                                            id={servico.OsId}
                                                            click={this.controller.selecionar}
                                                            colunas={[...this.controller.todasColunas]}
                                                            titulo={"OsId"}
                                                        />
                                                    )
                                                })

                                            }
                                        </div>
                                    }
                                    
                                </div>
                            );
                        })
                    }
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/importacao/components/TabelaOrcamentoImport.js